import {Component, Input} from '@angular/core';
import {CoreModule} from "../../_core/core.module";

@Component({
	selector: 'app-offer-attributes',
	standalone: true,
	imports: [
		CoreModule
	],
	templateUrl: './offer-attributes.component.html',
	styleUrl: './offer-attributes.component.scss'
})
export class OfferAttributesComponent {
	@Input() public mode: any;
	@Input() public offer: any;
}
